import { useAuthContext } from "@/components/AuthProvider";
import Box from "@/components/Box";
import ReleaseButton from "@/components/navigation/common/ReleaseButton";
import {
  dashboardPageMaxWidth,
  dashboardPagePx
} from "@/components/organisations/learningHub/dashboardLayout";
import { CMP_DASHBOARD_URL } from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import RegenerusLogo from "@/images/RegenerusLogoWithoutDots";
import BasketIcon from "@/images/tpo/basket.svg?react";
import { PanelBoxV2 } from "@/tpo/Boxes";
import Group from "@/tpo/Group";
import LinkWrapper from "@/tpo/LinkWrapper";
import { ActionIcon } from "@/v2/Buttons";

import AccountsMenu from "../common/AccountsMenu";
import { LARGE_DESKTOP_NAV_DISPLAY } from "../common/navDisplay";
import CmpDashboardNav from "./CmpDashboardNav";
import BurgerMenu from "./PractitionerLoggedInBurgerMenu";

export default function PractitionerLoggedInNavigation({
  accounts = [],
  onBasketClick,
  basketCount = 0,
  hideNav = false,
  hideBasket = false
}) {
  const authContext = useAuthContext();
  const impersonated = authContext?.user?.impersonated;
  const { resolvedUrls } = useCmpRelatedUrl();

  return (
    <PanelBoxV2
      maxWidth={dashboardPageMaxWidth}
      outer={{
        px: dashboardPagePx,
        position: "fixed",
        top: 40,
        left: 0,
        right: 0,
        bg: "transparent",
        zIndex: 4,
        "data-component-name": "LoggedOutNavHeader"
      }}
      inner={{
        height: [48, 48, 60]
      }}
    >
      <Group
        alignItems="center"
        justifyContent="space-between"
        gap={10}
        data-component-name="LoggedInNavigation"
        height={[48, 48, 60]}
      >
        <Box
          flexGrow={1}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          bg="dark"
          height="100%"
          borderRadius="10px"
          pl={24}
        >
          <Group>
            <Box
              as={LinkWrapper}
              to={resolvedUrls[CMP_DASHBOARD_URL]}
              display="flex"
              alignItems="center"
              aria-label="Dashboard"
              data-component-name="NavLogo"
            >
              <RegenerusLogo fill="white" width={[125, 158, 215]} height={30} />
            </Box>
            {impersonated && <ReleaseButton user={authContext?.user} />}
          </Group>
          {!hideNav && (
            <Group alignItems="center">
              <CmpDashboardNav />
              <AccountsMenu accounts={accounts} display={LARGE_DESKTOP_NAV_DISPLAY} />
              <BurgerMenu
                accounts={accounts}
                burgerButtonProps={{ height: [48, 48, 60], width: [48, 48, 60] }}
              />
            </Group>
          )}
        </Box>

        {/* Right box with basket icon */}
        {!hideBasket && (
          <Box
            bg="dark"
            p={20}
            borderRadius="10px"
            height={[48, 48, 60]}
            width={[48, 48, 60]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            position="relative"
          >
            <ActionIcon
              onClick={onBasketClick}
              data-component-name="BasketButton"
              gap={10}
              p={0}
              size={null}
            >
              <BasketIcon height={20} />
            </ActionIcon>
            {basketCount > 0 && (
              <Box
                bg="green"
                fontSize={12}
                fontFamily="gilroyBold"
                py={0}
                px={0}
                width={24}
                height={24}
                position="absolute"
                top={[-18, -18, -12]}
                right={[-12]}
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                data-component-name="BasketButtonCount"
              >
                {basketCount}
              </Box>
            )}
          </Box>
        )}
      </Group>
    </PanelBoxV2>
  );
}
